import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import {
  AdministrationResultStatus,
  HolidayData,
} from "../../../clients/system-api/SystemApiClient";
import { HolidayService } from 'src/app/services/holiday.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-holiday-day-popup',
  templateUrl: './holiday-day-popup.component.html',
  styleUrls: ['./holiday-day-popup.component.scss']
})
export class HolidayDayPopupComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();

  holidayData = new HolidayData();
  yesterday = new Date();

  constructor(private holidayService: HolidayService,
    private _snackBarService: SnackBarService) {
    this.yesterday.setDate(this.yesterday.getDate() - 0)
  }

  ngOnInit(): void {

  }

  addHoliday() {
    this.holidayData.date?.setHours(this.holidayData.date?.getHours() + 1)
    this.holidayData.dateTo?.setHours(this.holidayData.dateTo?.getHours() + 1)
    this.holidayService.addHoliday(this.holidayData).subscribe((data) => {
      this._snackBarService.callSnackBar(data, "Successfully entered");
      if (data == AdministrationResultStatus.Success) {
        this.closePopup();
      }
    }, error => {
      this._snackBarService.callSnackBar(error);
    });
  }

  closePopup() {
    this.close.emit();
  }

  filterSundays = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    return day !== 0;
  };

}
